module.exports = __webpack_public_path__ + "img/51.5d3ebef8.jpg";